module.exports = __webpack_public_path__ + "img/sozialschnellgut_7_b.02453087.jpg";